import React, { useState, useEffect, useRef } from 'react';
import './ProfessionalPage.css'; // Reuse existing styles/variables

const PythonPlayground = ({ initialCode, onClose }) => {
    const [code, setCode] = useState(initialCode);
    const [output, setOutput] = useState("Initializing Python environment...\n");
    const [isRunning, setIsRunning] = useState(false);
    const [pyodide, setPyodide] = useState(null);

    // Load Pyodide once
    useEffect(() => {
        const loadPyodideEngine = async () => {
            if (!window.loadPyodide) {
                setOutput("Error: Pyodide failed to load. Please refresh.");
                return;
            }
            try {
                const py = await window.loadPyodide();
                setPyodide(py);
                setOutput("Ready! Click 'Run' to execute code.\n");
            } catch (err) {
                setOutput(`Error loading Python: ${err.message}`);
            }
        };
        loadPyodideEngine();
    }, []);

    const runCode = async () => {
        if (!pyodide) return;
        setIsRunning(true);
        try {
            // Redirect stdout to capture print statements
            pyodide.setStdout({
                batched: (msg) => {
                    setOutput(prev => prev + msg + "\n");
                }
            });

            // Clear previous output (optional, or keep history)
            setOutput(">>> Running...\n");

            // Execute the code
            await pyodide.runPythonAsync(code);

            // If the user defines a function but doesn't call it, we can't easily guess.
            // But we can check if they are just defining functions and prompt them.
            // For now, simple execution.

        } catch (err) {
            setOutput(prev => prev + `\nTraceback (most recent call last):\n${err.message}`);
        } finally {
            setIsRunning(false);
        }
    };

    return (
        <div className="python-playground-overlay">
            <div className="python-playground-modal">
                <div className="playground-header">
                    <h3>Python Playground 🐍</h3>
                    <button className="close-playground" onClick={onClose}>×</button>
                </div>

                <div className="playground-body">
                    <div className="editor-section">
                        <div className="editor-toolbar">
                            <span>main.py</span>
                            <button
                                className="run-btn"
                                onClick={runCode}
                                disabled={!pyodide || isRunning}
                            >
                                {isRunning ? 'Running...' : '▶ Run'}
                            </button>
                        </div>
                        <textarea
                            className="code-editor"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            spellCheck="false"
                        />
                    </div>

                    <div className="output-section">
                        <div className="output-toolbar">
                            <span>Output / Terminal</span>
                            <button className="clear-btn" onClick={() => setOutput("")}>Clear</button>
                        </div>
                        <pre className="terminal-output">{output}</pre>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PythonPlayground;
